import { useMemo } from "react";

import { RVSideNavLayout, type PageSubNavItem } from "@regal-voice/ui";
import { usePageAvailability } from "App/routes/Hooks/usePageAvilability/usePageAvailability";
import { TOP_LEVEL_PAGES_TITLE_MAP } from "App/routes/pageNames";
import { AppPagePaths } from "App/routes/paths";
import { CollapsiblePanel } from "Utils/CollapsiblePanels";
import { useKnownPanels } from "Utils/CollapsiblePanels/knownPanels";

import { LIVE_OPS_SUB_NAV_TITLES } from "../liveopsMetadata";
import { liveOpsPathResources } from "../Pages/liveOpsPaths";
import { taskPathResources } from "../Pages/TasksPage/Pages/taskPaths";

export function LiveOpsSubNav(): JSX.Element {
    const { liveOpsPages } = usePageAvailability();
    const { showTasks, showAgents, showQueues, showRecentActivity } = liveOpsPages;

    const items: PageSubNavItem[] = useMemo(() => {
        const navItems: PageSubNavItem[] = [];

        if (showTasks) {
            navItems.push({
                key: liveOpsPathResources.tasks,
                title: LIVE_OPS_SUB_NAV_TITLES[liveOpsPathResources.tasks],
                href: `/${liveOpsPathResources.tasks}/${taskPathResources.upcoming}`,
                children: [
                    {
                        key: `${liveOpsPathResources.tasks}/${taskPathResources.upcoming}`,
                        title: LIVE_OPS_SUB_NAV_TITLES[taskPathResources.upcoming],
                        href: `/${liveOpsPathResources.tasks}/${taskPathResources.upcoming}`,
                    },
                    {
                        key: `${liveOpsPathResources.tasks}/${taskPathResources.past}`,
                        title: LIVE_OPS_SUB_NAV_TITLES[taskPathResources.past],
                        href: `/${liveOpsPathResources.tasks}/${taskPathResources.past}`,
                    },
                ],
            });
        }

        if (showAgents) {
            navItems.push({
                key: liveOpsPathResources.agents,
                title: LIVE_OPS_SUB_NAV_TITLES[liveOpsPathResources.agents],
                href: `/${liveOpsPathResources.agents}`,
            });
        }

        if (showQueues) {
            navItems.push({
                key: liveOpsPathResources.queues,
                title: LIVE_OPS_SUB_NAV_TITLES[liveOpsPathResources.queues],
                href: `/${liveOpsPathResources.queues}`,
            });
        }

        if (showRecentActivity) {
            navItems.push({
                key: liveOpsPathResources.recentActivity,
                title: LIVE_OPS_SUB_NAV_TITLES[liveOpsPathResources.recentActivity],
                href: `/${liveOpsPathResources.recentActivity}`,
            });
        }

        return navItems;
    }, [showTasks, showAgents, showQueues, showRecentActivity]);

    const { liveOps } = useKnownPanels();

    return (
        <CollapsiblePanel panelName={liveOps.name} expandedWidth={liveOps.width}>
            <RVSideNavLayout
                sidenavTitle={TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.liveOps]}
                items={items}
                basePath={AppPagePaths.liveOps}
                hasSubPages
                defaultOpenKeys={[liveOpsPathResources.tasks]}
            />
        </CollapsiblePanel>
    );
}
